
import './ProjectCard.css'
import { lP, URL_STRAPI } from '../core.js'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDiagramProject } from '@fortawesome/free-solid-svg-icons'

export default function ProjectCard(props) {
    // console.log("Logo", props.logo_img);

    return (
        <div className={'projectcard noselect ' + props.className} onClick={() => lP('/projects/' + props.projectid)}>

            {props.logo_img == undefined ?
                <FontAwesomeIcon className='newscardicon' icon={faDiagramProject} />
                :
                <img className='projectcardlogo' src={`${URL_STRAPI}${props.logo_img?.url}`} alt={"Logo des Projekts: " + props.logo_img?.alternativeText} />
            }
            <div className='projectcardtextcont'>
                {/* Echter, crawlbarer Link auf die Projektseite (Karte bleibt als Ganzes klickbar). */}
                <b>
                    <a
                        href={'/projects/' + props.projectid}
                        className='projectcard_titlelink'
                        style={{ textDecoration: 'none', color: 'inherit' }}
                    >
                        {props.name}
                    </a>
                </b>
                <p>{props.shortdescription}</p>
                {props.type == "kunde" && (
                    <div className='projectcardkundecont'>
                        <img className='projectcardkundelogo' src={`${URL_STRAPI}${props.kunde_logo?.url}`} alt={"Logo des Kunden: " + props.kunde_logo?.alternativeText} />
                        <a
                            href={props.kunde_url_landing}
                            target='_blank'
                            rel='noopener'
                            onClick={(e) => e.stopPropagation()}
                        >{props.kunde_name}</a>
                    </div>
                )}
            </div>

        </div>
    )
}
